import { Text, styled } from '@volkswagen-onehub/components-core';

export const RetailerFinanceTerms = styled(Text)(
  ({ theme }) => `
    color: ${theme.colors.content.secondary};
`);
